const actions = {
    GET_ALBUMS_LIST_SUCCESS: 'GET_ALBUMS_LIST_SUCCESS',
    SET_TYPE: 'SET_TYPE',
    ADD_TAB: 'ADD_TAB',
    GET_SELECTED_ALBUM_SUCCESS: 'GET_SELECTED_ALBUM_SUCCESS',
    ADD_TO_FAVOURITES: 'ADD_TO_FAVOURITES',
    ADD_TO_QUEUE: 'ADD_TO_QUEUE',
    PLAYLIST_MODAL: 'PLAYLIST_MODAL',
    CREATE_PLAYLIST: 'CREATE_PLAYLIST',
    SEARCH_RESULTS: 'SEARCH_RESULTS',
    PLAY_SONG: 'PLAY_SONG',
    UPDATE_SONG_LIST: 'UPDATE_SONG_LIST',
    UPDATE_QUEUE: 'UPDATE_QUEUE',
    ACTIVE_TAB_KEY: 'ACTIVE_TAB_KEY',
    LOADER: 'LOADER',
    CLEAR_TABS: 'CLEAR_TABS',
    MESSAGE_CONTENT: 'MESSAGE_CONTENT',
}

export default actions;